export type ColorOption = { bg: string; border: string };

export const palette: Record<string, ColorOption[]> = {
    regular: [
        { bg: "#e0e7ff", border: "#a5b4fc" }, // scheduler default (indigo-100/300)
        { bg: "#eef2ff", border: "#818cf8" },
        { bg: "#c7d2fe", border: "#6366f1" },
        { bg: "#dbeafe", border: "#93c5fd" },
        { bg: "#eff6ff", border: "#60a5fa" },
    ],
    approved: [
        { bg: "#dcfce7", border: "#4ade80" }, // scheduler default (green-100/400)
        { bg: "#f0fdf4", border: "#86efac" },
        { bg: "#d1fae5", border: "#34d399" },
        { bg: "#ecfdf5", border: "#6ee7b7" },
        { bg: "#bbf7d0", border: "#16a34a" },
    ],
    submitted: [
        { bg: "#fffbeb", border: "#fcd34d" }, // amber-50 / amber-300
        { bg: "#fef3c7", border: "#fbbf24" }, // amber-100 / amber-400
        { bg: "#ffedd5", border: "#fb923c" }, // orange-100 / orange-400
        { bg: "#fff7ed", border: "#fdba74" }, // orange-50 / orange-300
        { bg: "#fefce8", border: "#eab308" }, // yellow-50 / yellow-500
    ],
    locked: [
        { bg: "#ede9fe", border: "#a78bfa" }, // scheduler default (violet-100/400)
        { bg: "#faf5ff", border: "#d8b4fe" },
        { bg: "#f3e8ff", border: "#c084fc" },
        { bg: "#f5f3ff", border: "#c4b5fd" },
        { bg: "#fdf4ff", border: "#e879f9" },
    ],
    openShift: [
        { bg: "#f5f5f5", border: "#d4d4d4" }, // gray
        { bg: "#f8fafc", border: "#cbd5e1" }, // slate
        { bg: "#f9fafb", border: "#d1d5db" }, // cool gray
        { bg: "#fafaf9", border: "#d6d3d1" }, // stone
        { bg: "#f8fafc", border: "#a3a3a3" }, // darker neutral
    ],
};

export const shiftTypes = [
    { key: "regular", fieldName: "colors.regular", paletteKey: "regular" },
    { key: "approved", fieldName: "colors.approved", paletteKey: "approved" },
    { key: "submitted", fieldName: "colors.submitted", paletteKey: "submitted" },
    { key: "locked", fieldName: "colors.locked", paletteKey: "locked" },
    { key: "open-shift", fieldName: "colors.openShift", paletteKey: "openShift" },
] as const;
